export const getUserConsent = (): boolean => {
    // Check localStorage for consent
    const consent = localStorage.getItem('analyticsConsent');
    return consent === 'true'; // Return true if consent is explicitly given
};